<div class="p-6" style="min-width: 300px;">

    <!-- Title -->
    <h2 class="text-center font-bold text-xl mb-5 orange-text">Create Rebate</h2>

    <div class="flex flex-col justify-center items-center gap-2">
         <!-- Tier dropdown -->
        <div class="w-full mb-2" style="width: 320px;">
            <app-custom-dropdown-v2
                label="Tier:"
                labelWidth="130px"
                [options]="tierOptions"
                [selectedText]="selectedTierText"
                placeholder="— Choose a Tier —"
                (selectionChange)="onTierChange($event)">
            </app-custom-dropdown-v2>
        </div>

        <!-- Network Provider dropdown -->
        <div class="mb-2" style="width: 320px;">
            <app-custom-dropdown-v2
                label="Network Provider:"
                labelWidth="130px"
                [options]="providerOptions"
                [selectedText]="selectedProviderText"
                placeholder="== Select an option =="
                (selectionChange)="onProviderChange($event)">
            </app-custom-dropdown-v2>
        </div>
    
        <!-- Rebate Percentage -->
        <div class="flex flex-col" style="width: 320px;">
            <div class="card-input flex items-center text-xs py-2"
                [class.border-red-500]="rebatePercentage !== null && rebatePercentage > 100"
                [style.border-color]="rebatePercentage !== null && rebatePercentage > 100 ? '#e3342f' : ''">
                <span class="text-xs w-230-px font-semibold">Rebate Percentage (%):</span>
                <input
                    class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic input-no-spinner"
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    placeholder="Insert Percentage Value"
                    [(ngModel)]="rebatePercentage"
                    appOnlyNumber 
                    [allowDecimal]="true"
                >
            </div>
            <span *ngIf="rebatePercentage !== null && rebatePercentage > 100"
                class="italic font-semibold mt-1"
                style="color: #e3342f; font-size: 10px;">
                Percentage Value From 0% - 100% Only !
            </span>
        </div>
    </div>

    <!-- Action buttons -->
    <div class="flex items-center justify-center gap-3 mt-4">
        <span 
            [style.cursor]="(isLoading || isPercentageInvalid) ? 'not-allowed' : 'pointer'"
            [matTooltip]="isPercentageInvalid ? 'Please enter a valid rebate percentage' : ''"
            [matTooltipDisabled]="!isPercentageInvalid"
            matTooltipPosition="left"
            matTooltipClass="custom-orange-tooltip"
        >
            <button
                (click)="submit()"
                [disabled]="isLoading || isPercentageInvalid"
                class="uppercase custom-btn power-btn3 active font-semibold text-sm"
                style="padding:8px 12px;">
                {{ isLoading ? 'Saving...' : 'Save Changes' }}
            </button>
        </span>
        <button
            (click)="cancel()"
            class="uppercase custom-btn power-btn3 font-semibold text-sm" style="padding: 8px 12px;">
            Cancel
        </button>
    </div>

</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>